<script>
	import { page } from '$app/stores';
	import Badge from '../Badge/Badge.svelte';
	import Logo from '../Logo/Logo.svelte';
	import scroll from '@resider/scroll';

	/** @type {String} */
	export let desktopWidth = '';
	/** @type {boolean | RegExpMatchArray | null } */
	export let hasGradientBackground = false;
	/** @type {boolean | RegExpMatchArray | null} */
	export let hasTransparentBackground = false;
	/** @type {String} */
	export let leftBadgeLabel = '';
	/** @type {boolean | RegExpMatchArray | null} */
	export let preventScrollHandling = false;
	/** @type {String} */
	export let rightBadgeLabel = '';
	/** @type {String} */
	export let scrollDirection = 'up';
	/** @type {boolean | RegExpMatchArray | null} */
	export let fixed = false;
	/** @type {number | undefined} */
	export let zIndex = undefined;
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<header
	class="header scrolled-{scrollDirection}"
	class:has-transparent-background={hasTransparentBackground}
	class:has-gradient-background={hasGradientBackground}
	class:prevent-scroll-handling={preventScrollHandling}
	class:sticky={$scroll.scrollY > 0 && !$page.params.explore}
	style:position={fixed ? 'fixed' : ''}
	style:z-index={zIndex}
	style:--desktop-width={desktopWidth}
	on:click
>
	<div class="inner mobile">
		<div class="left" data-testid="header-left-trigger">
			<slot name="left" />
			{#if leftBadgeLabel}
				<Badge size="xs">
					{leftBadgeLabel}
				</Badge>
			{/if}
		</div>
		<Logo href="/{$page?.params?.lang}" />
		<div class="right">
			<slot name="right" />
			{#if rightBadgeLabel}
				<Badge size="xs">
					{rightBadgeLabel}
				</Badge>
			{/if}
		</div>
	</div>

	<div class="inner desktop">
		<div class="left">
			<Logo href="/{$page?.params?.lang}" />
		</div>
		<div class="center">
			<slot name="centerDesktop" />
		</div>
		<div class="right">
			{#if $$slots.rightDesktop}
				<slot name="rightDesktop" />
			{:else}
				<slot name="right" />
			{/if}
		</div>
	</div>
</header>

<style>header{--logo-height:1.75rem;background:hsla(var(--hsl-white));height:var(--ui-header-height);position:sticky;top:calc(-1*var(--ui-header-height));left:0;right:0;transition:all var(--time-xs) ease-out;z-index:4}@media (min-width:767.02px){header{top:0}}header .inner{align-items:center;display:grid;grid-gap:.5rem;gap:.5rem;grid-template-columns:1fr auto 1fr;height:100%;padding-left:.875rem;padding-right:.875rem;max-width:100%;max-width:var(--layout-width, var(--desktop-width, 100%));width:100%}@media (min-width:767.02px){header{--logo-height:2.5rem}header:not(.has-blurred-background):not(.has-gradient-background):not(.has-transparent-background){border-bottom:1px solid hsla(var(--hsl-gray-extra-light))}}@media (max-width:767px){header.prevent-scroll-handling{top:0}}.has-transparent-background{background:0 0}.has-blurred-background{background:hsla(var(--hsl-white),.5);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px)}.has-gradient-background{background:0 0;background-image:linear-gradient(hsla(var(--hsl-white)),hsla(var(--hsl-white),1),hsla(var(--hsl-white),.75),hsla(var(--hsl-white),.4),hsla(var(--hsl-white),0))}.scrolled-up{top:0}@media (max-width:767px){.scrolled-up:not(.prevent-scroll-handling){top:0}.scrolled-up.sticky{box-shadow:var(--shadow-md)}}header :global(.logo){justify-self:center}.left{justify-self:start}.right{justify-self:end}.left,.right{align-items:center;cursor:pointer;display:flex;position:relative}.left :global(.badge),.right :global(.badge){--hsl-badge-background:var(--hsl-secondary);position:absolute;top:-.25rem;right:-.5rem}.mobile{display:contents}@media (min-width:767.02px){.mobile{display:none!important}}.mobile :global(.icon){--size:1.75rem}.desktop{margin:auto;max-width:var(--layout-width)}@media (max-width:767px){.desktop{display:none!important}}</style>
